import { render, staticRenderFns } from "./wl-control.vue?vue&type=template&id=1dbb569a&lang=pug"
import script from "./wl-control.js?vue&type=script&lang=js&external"
export * from "./wl-control.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbb569a')) {
      api.createRecord('1dbb569a', component.options)
    } else {
      api.reload('1dbb569a', component.options)
    }
    module.hot.accept("./wl-control.vue?vue&type=template&id=1dbb569a&lang=pug", function () {
      api.rerender('1dbb569a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-control/wl-control.vue"
export default component.exports